// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2yb8i","header":"ClearentDisclaimer_header__3cDpw","inner":"ClearentDisclaimer_inner__1stGR"};